import { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';
import {
  ProjectStakeholder,
  createProjectStakeholder,
} from '../../services/commercialProjectsApi';
import { getRequestErrorMessage } from '../../utils/getRequestErrorMessage';
import { ModalPortalShell } from '../ui/ModalPortalShell';
import { RequiredMark } from '../ui/RequiredMark';

type StakeholderQuickCreateModalProps = {
  open: boolean;
  projectId: string;
  onClose: () => void;
  onCreated: (stakeholder: ProjectStakeholder) => void;
};

export function StakeholderQuickCreateModal({
  open,
  projectId,
  onClose,
  onCreated,
}: StakeholderQuickCreateModalProps) {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [organization, setOrganization] = useState('');
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  async function handleSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const stakeholder = await createProjectStakeholder(projectId, {
        name: name.trim(),
        role: role.trim() || undefined,
        organization: organization.trim() || undefined,
        email: email.trim() || undefined,
        influence: 'Medium',
        interest: 'Medium',
        commitmentStatus: 'Pending',
      });
      toast.success('Stakeholder cadastrado.');
      onCreated(stakeholder);
      setName('');
      setRole('');
      setOrganization('');
      setEmail('');
      onClose();
    } catch (error) {
      toast.error(getRequestErrorMessage(error, 'Falha ao cadastrar stakeholder.'));
    } finally {
      setSaving(false);
    }
  }

  return (
    <ModalPortalShell open={open} panelClassName="erp-card max-w-md shadow-xl" overlayClassName="z-[60]">
      <form onSubmit={(event) => void handleSubmit(event)} className="flex min-h-0 flex-1 flex-col">
        <div className="shrink-0 border-b border-secondary-200 px-5 py-4">
          <h3 className="erp-card-title">Novo stakeholder</h3>
          <p className="text-sm text-secondary-600">
            Cadastro rápido para incluir a pessoa na reunião. Ela passa a constar em Stakeholders.
          </p>
        </div>
        <div className="erp-card-body erp-form min-h-0 flex-1 overflow-y-auto">
          <label className="erp-label">
            Nome <RequiredMark />
            <input
              className="erp-input"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
              autoFocus
              maxLength={200}
            />
          </label>
          <div className="erp-form-grid">
            <label className="erp-label">
              Papel
              <input className="erp-input" value={role} onChange={(event) => setRole(event.target.value)} />
            </label>
            <label className="erp-label">
              Organização
              <input
                className="erp-input"
                value={organization}
                onChange={(event) => setOrganization(event.target.value)}
              />
            </label>
          </div>
          <label className="erp-label">
            E-mail
            <input
              type="email"
              className="erp-input"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
        </div>
        <div className="erp-btn-actions shrink-0 border-t border-secondary-200 bg-white px-5 py-4">
          <button type="button" className="erp-btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" disabled={saving} className="erp-btn-primary">
            {saving ? 'Salvando...' : 'Cadastrar'}
          </button>
        </div>
      </form>
    </ModalPortalShell>
  );
}
